export enum DropzoneContexts {
  CollectionAddBackground = 'COLLECTION_ADD_BACKGROUND',
  CollectionAddThumbnail = 'COLLECTION_ADD_THUMBNAIL',
  ContentItemInline = 'CONTENT_ITEM_INLINE',
  ContentItemAddThumbnail = 'CONTENT_ITEM_ADD_THUMBNAIL',
  ContentItemsPage = 'CONTENT_ITEMS_PAGE',
  ContentTree = 'CONTENT_TREE',
}
